import React, { useState, useEffect } from 'react';
import { Badge, CircularProgress } from '@mui/material';
import messageService from '../../services/messageService';
import { useAuth } from '../../contexts/AuthContext';

const MessageBadge = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchUnreadCount = async () => {
    if (!isAuthenticated) {
      setUnreadCount(0);
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      const response = await messageService.getUnreadMessageCount();
      if (response.success) {
        setUnreadCount(response.count);
      }
    } catch (error) {
      console.error('Error fetching unread message count:', error);
      setUnreadCount(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUnreadCount();
    // Frissítsük az olvasatlan üzenetek számát bizonyos időközönként (pl. 30 másodpercenként)
    const interval = setInterval(fetchUnreadCount, 30000); 
    return () => clearInterval(interval);
  }, [isAuthenticated]);

  if (loading) {
    return (
      <Badge color="primary" badgeContent={<CircularProgress size={10} color="inherit" />}>
        {children}
      </Badge>
    );
  }

  return (
    <Badge badgeContent={unreadCount} color="primary" max={99}>
      {children}
    </Badge>
  );
};

export default MessageBadge;